import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportingParameters } from '@stockcare-models/ReportingParameters';
import { StockCountConsolidated } from '@stockcare-models/StockCountConsolidated';
import { StockCountCounts } from '@stockcare-models/StockCountCounts';
import { StockCountConsolidatedHeader } from '@stockcare-models/StockCountConsolidatedHeader';
import { ConfigService } from '@stockcare-services/config-service/config.service';
import { Observable } from 'rxjs';
import { StockCountCountItems } from '@stockcare-models/StockCountCountItems';

import { Bin } from '@stockcare-models/Bin';
import { IMaterial } from '@stockcare-models/IMaterial';
import { BinMaterialDetails } from '@stockcare-models/BinMaterialDetails';
import { StockCountConsolidatedExport } from '@stockcare-models/StockCountConsolidatedExport';
import { StockCountCountExport } from '@stockcare-models/StockCountCountExport';
import { StockCountCountHeader } from '@stockcare-models/StockCountCountHeader';
import { StockCountPiExport } from '@stockcare-models/StockCountPiExport';
import { StockCountBinImport } from '@stockcare-models/StockCountBinImport';
import { StockCountBinDetailsImport } from '@stockcare-models/StockCountBinDetailsImport';
import { StockCountImport } from '@stockcare-models/StockCountImport';

@Injectable({
  providedIn: 'root'
})
export class StockCountingService {
  bins: Bin[] = [];
  constructor(
    private http: HttpClient,
    private conf: ConfigService,
  ) { }

  
  getConsolidatedHeader(FromDate: Date, ToDate: Date,PreviousFromDate: Date, PreviousToDate: Date, Institution: number): Observable<StockCountConsolidatedHeader> {

    var parameters = new ReportingParameters();
    parameters.DateFrom = FromDate;
    parameters.DateTo = ToDate;
    parameters.PreviousDateFrom = PreviousFromDate;
    parameters.PreviousDateTo = PreviousToDate;
    parameters.InstitutionReferenceId = Institution.toString();

    return this.http.post<StockCountConsolidatedHeader>(
      `${this.conf.config.baseUrl}/stockcounting/GetConsolidatedHeader`, parameters      
    );
  }

  getCountHeader(consolidatedCountNumber: string): Observable<StockCountCountHeader> {
    return this.http.get<StockCountCountHeader>(
      `${this.conf.config.baseUrl}/stockcounting/GetCountHeader/${consolidatedCountNumber}`);
  }

  getConsolidatedList(FromDate: Date, ToDate: Date, Institution: string): Observable<StockCountConsolidated[]> {

    var parameters = new ReportingParameters();
    parameters.DateFrom = FromDate;
    parameters.DateTo = ToDate;
    parameters.InstitutionReferenceId = Institution.toString();

    return this.http.post<StockCountConsolidated[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetConsolidatedList`, parameters      
    );
  }

  getCountList(consolidatedNumber: string): Observable<StockCountCounts[]> {
    var parameters = new ReportingParameters();
    parameters.InstitutionReferenceId = consolidatedNumber;

    return this.http.post<StockCountCounts[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetCountList`, parameters      
    );
  }

  getCountItemsList(countNumber: string): Observable<StockCountCountItems[]> {
    var parameters = new ReportingParameters();
    parameters.InstitutionReferenceId = countNumber;

    return this.http.post<StockCountCountItems[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetCountItemsList`, parameters      
    );
  }

  addStockCountConsolidated(institution: number, plannedDate: Date, stockCountType: string, countReference: string): Observable<any> {
    var parameters = {
      countReference: countReference,
      institutionId: institution,
      plannedDate: plannedDate,
      stockCountType: stockCountType
    };

    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/AddStockCountConsolidated`, parameters      
    );
  }

  addStockCountConsolidatedToExisting(institution: number, plannedDate: Date, stockCountType: string, countReference: string): Observable<any> {
    var parameters = {
      countReference: countReference,
      institutionId: institution,
      plannedDate: plannedDate,
      stockCountType: stockCountType
    };

    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/AddStockCountConsolidatedToExisting`, parameters      
    );
  }

  getBinsByStockLocationId(stockLocationId: number): Observable<Bin[]> {
    return this.http.get<Bin[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetBinsByStockLocationId/${stockLocationId}`      
    );
  }

  getBinsDetailByStockLocationId(stockLocationId: number): Observable<Bin[]> {
    if(stockLocationId == undefined)
      stockLocationId = 0;

    return this.http.get<Bin[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetBinsDetailByStockLocationId/${stockLocationId}`      
    );
  }

  getMaterialsForStockLocation(stockLocationId: number, pagerSize: number, currentPage: number, search: string): Observable<BinMaterialDetails[]> {
    if(stockLocationId == undefined)
      stockLocationId = 0;

    return this.http.get<BinMaterialDetails[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetMaterialsForStockLocation/${stockLocationId}/${pagerSize}/${currentPage}/${search}`      
    );
  }

  getMaterialsForStockLocationTotal(stockLocationId: number, search: string): Observable<BinMaterialDetails[]> {
    if(stockLocationId == undefined)
      stockLocationId = 0;

    return this.http.get<BinMaterialDetails[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetMaterialsForStockLocation/${stockLocationId}/${search}`      
    );
  }

  doesBinExists(stockLocationId: number, binName: string): Observable<boolean> {
     return this.http.get<boolean>(
      `${this.conf.config.baseUrl}/stockcounting/DoesBinExist/${stockLocationId}/${binName}`      
    );
  }

  addStockCountCountBin(consolidatedNumber: string, bins: Bin[]): Observable<any> {
    var parameters = {
      consolidatedNumber: consolidatedNumber,
      bins: bins
    };

    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/AddStockCountCountBin`, parameters      
    );
  }

  addStockCountCountMaterial(countNumber: string,stockLocationId: number, materials: IMaterial[]): Observable<any> {
    var parameters = {
      stockCountConsolidatedId: countNumber,
      stockLocationId: stockLocationId,
      materials: materials
    };

    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/AddStockCountCountMaterial`, parameters      
    );
  }

  addStockCountCountFull(countNumber: string,stockLocationId: number): Observable<any> {
    var parameters = {
      consolidatedNumber: countNumber,
      stockLocationId: stockLocationId
    };

    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/AddStockCountCountFull`, parameters      
    );
  }

  assignUserToCount(countId: number, userId: string, type: string): Observable<any> {
    var parameters = {
      countId: countId,
      userId: userId,
      type: type
    };

    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/AssignUserToCount`, parameters      
    );
  }

  addBin(stockLocationId: number, binName: string, binSequence: string, materials: BinMaterialDetails[]): Observable<any> {
    var parameters = {
      stockLocationId: stockLocationId,
      binName: binName,
      binSequence: binSequence,
      materials: materials
    };

    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/AddBin`, parameters      
    );
  }

  deleteBinItem(binId: number): Observable<any> {
    return this.http.delete<any>(
      `${this.conf.config.baseUrl}/stockcounting/BinItem/${binId}`      
    );
  }

  updateBinItemSequence(payload: any): Observable<any> {
    return this.http.put<any>(
      `${this.conf.config.baseUrl}/stockcounting/UpdateBinItemSequence`, payload   
    );
  }

  deleteBin(binId: string, stockLocationId: number): Observable<any> {
    return this.http.delete<any>(
      `${this.conf.config.baseUrl}/stockcounting/DeleteBin/${stockLocationId}/${binId}`     
    );
  }

  getConsolidatedExportData(consolidatedId: number): Observable<StockCountPiExport[]> {
    return this.http.get<StockCountPiExport[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetConsolidatedExportData/${consolidatedId}`      
    );
  }

  getPiExportData(piRef: string): Observable<StockCountPiExport[]> {
    return this.http.get<StockCountPiExport[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetPIExportData/${piRef}`      
    );
  }

  getCountCountExportData(countId: number): Observable<StockCountCountExport[]> {
    return this.http.get<StockCountConsolidatedExport[]>(
      `${this.conf.config.baseUrl}/stockcounting/GetCountCountExportData/${countId}`      
    );
  }

  canAddToConsollidated(consolidatedId: number, rowCount: number): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.conf.config.baseUrl}/stockcounting/CanAddToConsollidated/${consolidatedId}/${rowCount}`      
    );
  }

  getFilteredHistoricalCounts(parameters: ReportingParameters): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/GetFilteredHistoricalCounts`, parameters      
    );
  }

  getFilteredManualItems(parameters: ReportingParameters): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/GetFilteredManualItems`, parameters      
    );
  }

  getFilteredUserSetups(parameters: ReportingParameters): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/GetFilteredCounterSetup`, parameters      
    );
  }

  getFilteredBinSetup(parameters: ReportingParameters): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/GetFilteredBinSetup`, parameters      
    );
  }

  closeStockCountCountConsolidated(countReference: string,institutionId: number): Observable<any> {
    var parameters = {
      countReference: countReference,
      institutionId: institutionId
    };
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/CloseStockCountCountConsolidated` , parameters    
    );
  }

  deleteStockCount(id: number): Observable<any> 
  {
    return this.http.delete<any>(
      `${this.conf.config.baseUrl}/stockcounting/StockCount/${id}`    
    );
  }

  deleteConsolidatedStockCount(id: number): Observable<any> 
  {
    return this.http.delete<any>(
      `${this.conf.config.baseUrl}/stockcounting/ConsolidatedStockCount/${id}`    
    );
  }

  submitConsolidatedToSORsingle(id: number): Observable<any> {
    var parameters = {
      id: id
    };
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/SubmitConsolidatedToSORsingle` , parameters    
    );
  }

  testBinImport(binImport : StockCountBinImport[]): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/TestBinImport` , binImport    
    );
  }

  testBinDetailsImport(binImport : StockCountBinDetailsImport[]): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/TestBinDetailsImport` , binImport    
    );
  }

  binDetailsImport(binImport : StockCountBinDetailsImport[]): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/BinDetailsImport` , binImport    
    );
  }

  binImport(binImport : StockCountBinImport[]): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/BinImport` , binImport    
    );
  }
  
  testCountImport(countImport : StockCountImport[]): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/TestCountImport` , countImport    
    );
  }

  countImport(countImport : StockCountImport[]): Observable<any> {
    return this.http.post<any>(
      `${this.conf.config.baseUrl}/stockcounting/CountImport` , countImport    
    );
  }


  
}



